import React from 'react';
import CKEditor from '../ReactCKEditor';
import { CKEditorEvent } from 'src/types/types';

interface XplorActiveNotifyContentEditorProps {
  events?: { [key: string]: (ckEvent: CKEditorEvent) => void };
  config?: { [key: string]: unknown };
  content?: string;
  name?: string;
}

const XplorActiveNotifyContentEditor = ({
  name = 'xplNotifCtnEditor',
  content,
  config,
  events,
}: XplorActiveNotifyContentEditorProps) => (
  <div>
    <CKEditor
      name={name}
      config={{
        removeButtons:
          'Underline,Subscript,Superscript,' +
          'Source,Anchor,Maximize,About,Copy,Paste,PasteText,PasteFromWord,' +
          'Cut,Scayt,Undo,Redo,Form,Checkbox,Radio,TextField,Textarea,Select,Button,' +
          'ImageButton,HiddenField,Bold,Italic,Underline,Strike,Subscript,Superscript,' +
          'RemoveFormat,NumberedList,BulletedList,Outdent,Indent,Blockquote,CreateDiv,' +
          'JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,' +
          'BidiLtr,BidiRtl,CreatePlaceholder,' +
          'Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,InsertPre,Styles,Format,Font,FontSize,Unlink,Link',
        extraPlugins: 'strinsert',
        removePlugins: 'colorbutton,elementspath',
        autoParagraph: false,
        enterMode: 2,
        allowedContent: true,
        height: 200,
        ...config,
      }}
      events={events}
      content={content}
    />
  </div>
);

export default XplorActiveNotifyContentEditor;
